import { ResponsiveConfig } from '../../../models/responsive-config';

export const responsiveBreakpoints: ResponsiveConfig<string> = {
  small: '(max-width: 991px)',
  medium: '(min-width: 992px)',
  large: '(min-width: 1200px)',
  extraLarge: '(min-width: 1400px)',
};
